interface IpResponse {
  ip: string
}

const googleBotAddresses: string[] = [
  "2001:4860:4801:10::/64",
  "2001:4860:4801:11::/64",
  "2001:4860:4801:12::/64",
  "2001:4860:4801:13::/64",
  "2001:4860:4801:14::/64",
  "2001:4860:4801:15::/64",
  "2001:4860:4801:16::/64",
  "2001:4860:4801:17::/64",
  "2001:4860:4801:18::/64",
  "2001:4860:4801:19::/64",
  "2001:4860:4801:1a::/64",
  "2001:4860:4801:1b::/64",
  "2001:4860:4801:1c::/64",
  "2001:4860:4801:1d::/64",
  "2001:4860:4801:1e::/64",
  "2001:4860:4801:1f::/64",
  "2001:4860:4801:20::/64",
  "2001:4860:4801:21::/64",
  "2001:4860:4801:22::/64",
  "2001:4860:4801:23::/64",
  "2001:4860:4801:24::/64",
  "2001:4860:4801:25::/64",
  "2001:4860:4801:26::/64",
  "2001:4860:4801:27::/64",
  "2001:4860:4801:28::/64",
  "2001:4860:4801:29::/64",
  "2001:4860:4801:2::/64",
  "2001:4860:4801:2a::/64",
  "2001:4860:4801:2b::/64",
  "2001:4860:4801:2c::/64",
  "2001:4860:4801:2d::/64",
  "2001:4860:4801:2e::/64",
  "2001:4860:4801:2f::/64",
  "2001:4860:4801:31::/64",
  "2001:4860:4801:32::/64",
  "2001:4860:4801:33::/64",
  "2001:4860:4801:34::/64",
  "2001:4860:4801:35::/64",
  "2001:4860:4801:36::/64",
  "2001:4860:4801:37::/64",
  "2001:4860:4801:38::/64",
  "2001:4860:4801:39::/64",
  "2001:4860:4801:3a::/64",
  "2001:4860:4801:3b::/64",
  "2001:4860:4801:3c::/64",
  "2001:4860:4801:3d::/64",
  "2001:4860:4801:3e::/64",
  "2001:4860:4801:40::/64",
  "2001:4860:4801:41::/64",
  "2001:4860:4801:42::/64",
  "2001:4860:4801:43::/64",
  "2001:4860:4801:44::/64",
  "2001:4860:4801:45::/64",
  "2001:4860:4801:46::/64",
  "2001:4860:4801:47::/64",
  "2001:4860:4801:48::/64",
  "2001:4860:4801:49::/64",
  "2001:4860:4801:4a::/64",
  "2001:4860:4801:4b::/64",
  "2001:4860:4801:50::/64",
  "2001:4860:4801:51::/64",
  "2001:4860:4801:53::/64",
  "2001:4860:4801:54::/64",
  "2001:4860:4801:55::/64",
  "2001:4860:4801:60::/64",
  "2001:4860:4801:61::/64",
  "2001:4860:4801:62::/64",
  "2001:4860:4801:63::/64",
  "2001:4860:4801:64::/64",
  "2001:4860:4801:65::/64",
  "2001:4860:4801:66::/64",
  "2001:4860:4801:67::/64",
  "2001:4860:4801:68::/64",
  "2001:4860:4801:69::/64",
  "2001:4860:4801:6a::/64",
  "2001:4860:4801:6b::/64",
  "2001:4860:4801:6c::/64",
  "2001:4860:4801:6d::/64",
  "2001:4860:4801:6e::/64",
  "2001:4860:4801:6f::/64",
  "2001:4860:4801:70::/64",
  "2001:4860:4801:71::/64",
  "2001:4860:4801:72::/64",
  "2001:4860:4801:73::/64",
  "2001:4860:4801:74::/64",
  "2001:4860:4801:75::/64",
  "2001:4860:4801:76::/64",
  "2001:4860:4801:77::/64",
  "2001:4860:4801:78::/64",
  "2001:4860:4801:79::/64",
  "2001:4860:4801:80::/64",
  "2001:4860:4801:81::/64",
  "2001:4860:4801:82::/64",
  "2001:4860:4801:83::/64",
  "2001:4860:4801:84::/64",
  "2001:4860:4801:85::/64",
  "2001:4860:4801:86::/64",
  "2001:4860:4801:87::/64",
  "2001:4860:4801:88::/64",
  "2001:4860:4801:90::/64",
  "2001:4860:4801:91::/64",
  "2001:4860:4801:92::/64",
  "2001:4860:4801:93::/64",
  "2001:4860:4801:94::/64",
  "2001:4860:4801:95::/64",
  "2001:4860:4801:a0::/64",
  "2001:4860:4801:a1::/64",
  "2001:4860:4801:a2::/64",
  "2001:4860:4801:c::/64",
  "2001:4860:4801:f::/64",
  "192.178.5.0",
  "192.178.6.0",
  "192.178.6.32",
  "192.178.6.64",
  "192.178.6.96",
  "34.100.182.96",
  "34.101.50.144",
  "34.118.254.0",
  "34.118.66.0",
  "34.126.178.96",
  "34.146.150.144",
  "34.147.110.144",
  "34.151.74.144",
  "34.152.50.64",
  "34.154.114.144",
  "34.155.98.32",
  "34.165.18.176",
  "34.175.160.64",
  "34.176.130.16",
  "34.22.85.0",
  "34.64.82.64",
  "34.65.242.112",
  "34.80.50.80",
  "34.88.194.0",
  "34.89.10.80",
  "34.89.198.80",
  "34.96.162.48",
  "35.247.243.240",
  "66.249.64.0",
  "66.249.64.128",
  "66.249.64.160",
  "66.249.64.224",
  "66.249.64.32",
  "66.249.64.64",
  "66.249.64.96",
  "66.249.65.0",
  "66.249.65.128",
  "66.249.65.160",
  "66.249.65.192",
  "66.249.65.224",
  "66.249.65.32",
  "66.249.65.64",
  "66.249.65.96",
  "66.249.66.0",
  "66.249.66.160",
  "66.249.66.192",
  "66.249.66.32",
  "66.249.66.64",
  "66.249.66.96",
  "66.249.68.0",
  "66.249.68.32",
  "66.249.68.64",
  "66.249.68.96",
  "66.249.69.0",
  "66.249.69.128",
  "66.249.69.160",
  "66.249.69.192",
  "66.249.69.224",
  "66.249.69.32",
  "66.249.69.64",
  "66.249.69.96",
  "66.249.70.0",
  "66.249.70.128",
  "66.249.70.160",
  "66.249.70.192",
  "66.249.70.224",
  "66.249.70.32",
  "66.249.70.64",
  "66.249.70.96",
  "66.249.71.0",
  "66.249.71.128",
  "66.249.71.160",
  "66.249.71.192",
  "66.249.71.224",
  "66.249.71.32",
  "66.249.71.64",
  "66.249.71.96",
  "66.249.72.0",
  "66.249.72.128",
  "66.249.72.160",
  "66.249.72.192",
  "66.249.72.224",
  "66.249.72.32",
  "66.249.72.64",
  "66.249.72.96",
  "66.249.73.0",
  "66.249.73.128",
  "66.249.73.160",
  "66.249.73.192",
  "66.249.73.224",
  "66.249.73.32",
  "66.249.73.64",
  "66.249.73.96",
  "66.249.74.0",
  "66.249.74.128",
  "66.249.74.160",
  "66.249.74.32",
  "66.249.74.64",
  "66.249.74.96",
  "66.249.75.0",
  "66.249.75.128",
  "66.249.75.160",
  "66.249.75.192",
  "66.249.75.224",
  "66.249.75.32",
  "66.249.75.64",
  "66.249.75.96",
  "66.249.76.0",
  "66.249.76.128",
  "66.249.76.160",
  "66.249.76.192",
  "66.249.76.224",
  "66.249.76.32",
  "66.249.76.64",
  "66.249.76.96",
  "66.249.77.0",
  "66.249.77.128",
  "66.249.77.160",
  "66.249.77.192",
  "66.249.77.224",
  "66.249.77.32",
  "66.249.77.64",
  "66.249.77.96",
  "66.249.78.0",
  "66.249.78.32",
  "66.249.79.0",
  "66.249.79.128",
  "66.249.79.160",
  "66.249.79.192",
  "66.249.79.224",
  "66.249.79.32",
  "66.249.79.64",
  "66.249.79.96",
  "2001:4860:4801:2008::/64",
  "2001:4860:4801:200c::/64",
  "2001:4860:4801:200d::/64",
  "2001:4860:4801:2010::/64",
  "2001:4860:4801:2011::/64",
  "2001:4860:4801:2012::/64",
  "2001:4860:4801:2013::/64",
  "2001:4860:4801:2014::/64",
  "2001:4860:4801:2015::/64",
  "2001:4860:4801:2016::/64",
  "2001:4860:4801:2017::/64",
  "2001:4860:4801:2018::/64",
  "2001:4860:4801:2019::/64",
  "2001:4860:4801:201a::/64",
  "2001:4860:4801:201b::/64",
  "2001:4860:4801:201c::/64",
  "2001:4860:4801:201d::/64",
  "2001:4860:4801:201e::/64",
  "2001:4860:4801:201f::/64",
  "2001:4860:4801:2020::/64",
  "2001:4860:4801:2021::/64",
  "2001:4860:4801:2022::/64",
  "2001:4860:4801:2023::/64",
  "2001:4860:4801:2024::/64",
  "2001:4860:4801:2025::/64",
  "2001:4860:4801:2026::/64",
  "2001:4860:4801:2027::/64",
  "2001:4860:4801:2028::/64",
  "2001:4860:4801:2029::/64",
  "2001:4860:4801:202a::/64",
  "2001:4860:4801:202b::/64",
  "2001:4860:4801:202c::/64",
  "2001:4860:4801:202d::/64",
  "2001:4860:4801:202e::/64",
  "2001:4860:4801:202f::/64",
  "2001:4860:4801:2031::/64",
  "2001:4860:4801:2032::/64",
  "2001:4860:4801:2033::/64",
  "2001:4860:4801:2034::/64",
  "2001:4860:4801:2035::/64",
  "2001:4860:4801:2036::/64",
  "2001:4860:4801:2037::/64",
  "2001:4860:4801:2038::/64",
  "2001:4860:4801:2039::/64",
  "2001:4860:4801:203a::/64",
  "2001:4860:4801:203b::/64",
  "2001:4860:4801:203c::/64",
  "2001:4860:4801:203d::/64",
  "2001:4860:4801:203e::/64",
  "2001:4860:4801:2040::/64",
  "2001:4860:4801:2041::/64",
  "2001:4860:4801:2042::/64",
  "2001:4860:4801:2043::/64",
  "2001:4860:4801:2044::/64",
  "2001:4860:4801:2045::/64",
  "2001:4860:4801:2046::/64",
  "2001:4860:4801:2047::/64",
  "2001:4860:4801:2048::/64",
  "2001:4860:4801:2049::/64",
  "2001:4860:4801:204a::/64",
  "2001:4860:4801:204b::/64",
  "2001:4860:4801:2050::/64",
  "2001:4860:4801:2051::/64",
  "2001:4860:4801:2052::/64",
  "2001:4860:4801:2053::/64",
  "2001:4860:4801:2054::/64",
  "2001:4860:4801:2060::/64",
  "2001:4860:4801:2061::/64",
  "2001:4860:4801:2062::/64",
  "2001:4860:4801:2063::/64",
  "2001:4860:4801:2064::/64",
  "2001:4860:4801:2065::/64",
  "2001:4860:4801:2066::/64",
  "2001:4860:4801:2067::/64",
  "2001:4860:4801:2068::/64",
  "2001:4860:4801:2069::/64",
  "2001:4860:4801:206a::/64",
  "2001:4860:4801:206b::/64",
  "2001:4860:4801:206c::/64",
  "2001:4860:4801:206d::/64",
  "2001:4860:4801:206e::/64",
  "2001:4860:4801:206f::/64",
  "2001:4860:4801:2070::/64",
  "2001:4860:4801:2071::/64",
  "2001:4860:4801:2072::/64",
  "2001:4860:4801:2073::/64",
  "2001:4860:4801:2074::/64",
  "2001:4860:4801:2075::/64",
  "2001:4860:4801:2076::/64",
  "2001:4860:4801:2077::/64",
  "2001:4860:4801:2078::/64",
  "2001:4860:4801:2079::/64",
  "2001:4860:4801:2080::/64",
  "2001:4860:4801:2081::/64",
  "2001:4860:4801:2082::/64",
  "2001:4860:4801:2083::/64",
  "2001:4860:4801:2084::/64",
  "2001:4860:4801:2085::/64",
  "2001:4860:4801:2086::/64",
  "2001:4860:4801:2087::/64",
  "2001:4860:4801:2088::/64",
  "2001:4860:4801:2090::/64",
  "2001:4860:4801:2091::/64",
  "2001:4860:4801:2092::/64",
  "2001:4860:4801:2093::/64",
  "2001:4860:4801:2094::/64",
  "2001:4860:4801:2095::/64",
  "2001:4860:4801:20a0::/64",
  "2001:4860:4801:20a1::/64",
  "2001:4860:4801:20a2::/64",
  "2001:4860:4801:c::/64",
  "2001:4860:4801:f::/64",
  "192.178.5.0",
  "192.178.6.0",
  "192.178.6.32",
  "192.178.6.64",
  "192.178.6.96",
  "34.100.182.96",
  "34.101.50.144",
  "34.118.254.0",
  "34.118.66.0",
  "34.126.178.96",
  "34.146.150.144",
  "34.147.110.144",
  "34.151.74.144",
  "34.152.50.64",
  "34.154.114.144",
  "34.155.98.32",
  "34.165.18.176",
  "34.175.160.64",
  "34.176.130.16",
  "34.22.85.0",
  "34.64.82.64",
  "34.65.242.112",
  "34.80.50.80",
  "34.88.194.0",
  "34.89.10.80",
  "34.89.198.80",
  "34.96.162.48",
  "35.247.243.240",
  "66.249.64.0",
  "66.249.64.128",
  "66.249.64.160",
  "66.249.64.224",
  "66.249.64.32",
  "66.249.64.64",
  "66.249.64.96",
  "66.249.65.0",
  "66.249.65.128",
  "66.249.65.160",
  "66.249.65.192",
  "66.249.65.224",
  "66.249.65.32",
  "66.249.65.64",
  "66.249.65.96",
  "66.249.66.0",
  "66.249.66.160",
  "66.249.66.192",
  "66.249.66.32",
  "66.249.66.64",
  "66.249.66.96",
  "66.249.68.0",
  "66.249.68.32",
  "66.249.68.64",
  "66.249.68.96",
  "66.249.69.0",
  "66.249.69.128",
  "66.249.69.160",
  "66.249.69.192",
  "66.249.69.224",
  "66.249.69.32",
  "66.249.69.64",
  "66.249.69.96",
  "66.249.70.0",
  "66.249.70.128",
  "66.249.70.160",
  "66.249.70.192",
  "66.249.70.224",
  "66.249.70.32",
  "66.249.70.64",
  "66.249.70.96",
  "66.249.71.0",
  "66.249.71.128",
  "66.249.71.160",
  "66.249.71.192",
  "66.249.71.224",
  "66.249.71.32",
  "66.249.71.64",
  "66.249.71.96",
  "66.249.72.0",
  "66.249.72.128",
  "66.249.72.160",
  "66.249.72.192",
  "66.249.72.224",
  "66.249.72.32",
  "66.249.72.64",
  "66.249.72.96",
  "66.249.73.0",
  "66.249.73.128",
  "66.249.73.160",
  "66.249.73.192",
  "66.249.73.224",
  "66.249.73.32",
  "66.249.73.64",
  "66.249.73.96",
  "66.249.74.0",
  "66.249.74.128",
  "66.249.74.160",
  "66.249.74.32",
  "66.249.74.64",
  "66.249.74.96",
  "66.249.75.0",
  "66.249.75.128",
  "66.249.75.160",
  "66.249.75.192",
  "66.249.75.224",
  "66.249.75.32",
  "66.249.75.64",
  "66.249.75.96",
  "66.249.76.0",
  "66.249.76.128",
  "66.249.76.160",
  "66.249.76.192",
  "66.249.76.224",
  "66.249.76.32",
  "66.249.76.64",
  "66.249.76.96",
  "66.249.77.0",
  "66.249.77.128",
  "66.249.77.160",
  "66.249.77.192",
  "66.249.77.224",
  "66.249.77.32",
  "66.249.77.64",
  "66.249.77.96",
  "66.249.78.0",
  "66.249.78.32",
  "66.249.79.0",
  "66.249.79.128",
  "66.249.79.160",
  "66.249.79.192",
  "66.249.79.224",
  "66.249.79.32",
  "66.249.79.64",
  "66.249.79.96",
  "2001:4860:4801:2008::/64",
  "2001:4860:4801:200c::/64",
  "2001:4860:4801:200d::/64",
  "2001:4860:4801:2010::/64",
  "2001:4860:4801:2011::/64",
  "2001:4860:4801:2012::/64",
  "2001:4860:4801:2013::/64",
  "2001:4860:4801:2014::/64",
  "2001:4860:4801:2015::/64",
  "2001:4860:4801:2016::/64",
  "2001:4860:4801:2017::/64",
  "2001:4860:4801:2018::/64",
  "2001:4860:4801:2019::/64",
  "2001:4860:4801:201a::/64",
  "2001:4860:4801:201b::/64",
  "2001:4860:4801:201c::/64",
  "2001:4860:4801:201d::/64",
  "2001:4860:4801:201e::/64",
  "2001:4860:4801:201f::/64",
  "2001:4860:4801:2020::/64",
  "2001:4860:4801:2021::/64",
  "2001:4860:4801:2022::/64",
  "2001:4860:4801:2023::/64",
  "2001:4860:4801:2024::/64",
  "2001:4860:4801:2025::/64",
  "2001:4860:4801:2026::/64",
  "2001:4860:4801:2027::/64",
  "2001:4860:4801:2028::/64",
  "2001:4860:4801:2029::/64",
  "2001:4860:4801:202a::/64",
  "2001:4860:4801:202b::/64",
  "2001:4860:4801:202c::/64",
  "2001:4860:4801:202d::/64",
  "2001:4860:4801:202e::/64",
  "2001:4860:4801:202f::/64",
  "2001:4860:4801:2031::/64",
  "2001:4860:4801:2032::/64",
  "2001:4860:4801:2033::/64",
  "2001:4860:4801:2034::/64",
  "2001:4860:4801:2035::/64",
  "2001:4860:4801:2036::/64",
  "2001:4860:4801:2037::/64",
  "2001:4860:4801:2038::/64",
  "2001:4860:4801:2039::/64",
  "2001:4860:4801:203a::/64",
  "2001:4860:4801:203b::/64",
  "2001:4860:4801:203c::/64",
  "2001:4860:4801:203d::/64",
  "2001:4860:4801:203e::/64",
  "2001:4860:4801:2040::/64",
  "2001:4860:4801:2041::/64",
  "2001:4860:4801:2042::/64",
  "2001:4860:4801:2043::/64",
  "2001:4860:4801:2044::/64",
  "2001:4860:4801:2045::/64",
  "2001:4860:4801:2046::/64",
  "2001:4860:4801:2047::/64",
  "2001:4860:4801:2048::/64",
  "2001:4860:4801:2049::/64",
  "2001:4860:4801:204a::/64",
  "2001:4860:4801:204b::/64",
  "2001:4860:4801:2050::/64",
  "2001:4860:4801:2051::/64",
  "2001:4860:4801:2052::/64",
  "2001:4860:4801:2053::/64",
  "2001:4860:4801:2054::/64",
  "2001:4860:4801:2060::/64",
  "2001:4860:4801:2061::/64",
  "2001:4860:4801:2062::/64",
  "2001:4860:4801:2063::/64",
  "2001:4860:4801:2064::/64",
  "2001:4860:4801:2065::/64",
  "2001:4860:4801:2066::/64",
  "2001:4860:4801:2067::/64",
  "2001:4860:4801:2068::/64",
  "2001:4860:4801:2069::/64",
  "2001:4860:4801:206a::/64",
  "2001:4860:4801:206b::/64",
  "2001:4860:4801:206c::/64",
  "2001:4860:4801:206d::/64",
  "2001:4860:4801:206e::/64",
  "2001:4860:4801:206f::/64",
  "2001:4860:4801:2070::/64",
  "2001:4860:4801:2071::/64",
  "2001:4860:4801:2072::/64",
  "2001:4860:4801:2073::/64",
  "2001:4860:4801:2074::/64",
  "2001:4860:4801:2075::/64",
  "2001:4860:4801:2076::/64",
  "2001:4860:4801:2077::/64",
  "2001:4860:4801:2078::/64",
  "2001:4860:4801:2079::/64",
  "2001:4860:4801:2080::/64",
  "2001:4860:4801:2081::/64",
  "2001:4860:4801:2082::/64",
  "2001:4860:4801:2083::/64",
  "2001:4860:4801:2084::/64",
  "2001:4860:4801:2085::/64",
  "2001:4860:4801:2086::/64",
  "2001:4860:4801:2087::/64",
  "2001:4860:4801:2088::/64",
  "2001:4860:4801:2090::/64",
  "2001:4860:4801:2091::/64",
  "2001:4860:4801:2092::/64",
  "2001:4860:4801:2093::/64",
  "2001:4860:4801:2094::/64",
  "2001:4860:4801:2095::/64",
  "2001:4860:4801:20a0::/64",
  "2001:4860:4801:20a1::/64",
  "2001:4860:4801:20a2::/64",
  "2001:4860:4801:c::/64",
  "2001:4860:4801:f::/64",
  "108.177.2.0/27",
  "108.177.2.32/27",
  "108.177.2.64/27",
  "108.177.2.96/27",
  "192.178.17.0/27",
  "209.85.238.0/27",
  "209.85.238.128/27",
  "209.85.238.160/27",
  "209.85.238.192/27",
  "209.85.238.224/27",
  "209.85.238.32/27",
  "209.85.238.64/27",
  "209.85.238.96/27",
  "66.249.87.0/27",
  "66.249.87.128/27",
  "66.249.87.160/27",
  "66.249.87.192/27",
  "66.249.87.224/27",
  "66.249.87.32/27",
  "66.249.87.64/27",
  "66.249.87.96/27",
  "66.249.89.0/27",
  "66.249.89.128/27",
  "66.249.89.160/27",
  "66.249.89.224/27",
  "66.249.89.32/27",
  "66.249.89.64/27",
  "66.249.89.96/27",
  "66.249.90.0/27",
  "66.249.90.128/27",
  "66.249.90.160/27",
  "66.249.90.192/27",
  "66.249.90.224/27",
  "66.249.90.32/27",
  "66.249.90.64/27",
  "66.249.90.96/27",
  "66.249.91.0/27",
  "66.249.91.128/27",
  "66.249.91.160/27",
  "66.249.91.192/27",
  "66.249.91.224/27",
  "66.249.91.32/27",
  "66.249.91.64/27",
  "66.249.91.96/27",
  "66.249.92.0/27",
  "66.249.92.128/27",
  "66.249.92.160/27",
  "66.249.92.192/27",
  "66.249.92.32/27",
  "66.249.92.96/27",
  "72.14.199.0/27",
  "72.14.199.128/27",
  "72.14.199.160/27",
  "72.14.199.192/27",
  "72.14.199.224/27",
  "72.14.199.32/27",
  "72.14.199.64/27",
  "72.14.199.96/27",
  "74.125.148.0/27",
  "74.125.148.128/27",
  "74.125.148.160/27",
  "74.125.148.192/27",
  "74.125.148.224/27",
  "74.125.148.32/27",
  "74.125.148.64/27",
  "74.125.148.96/27",
  "74.125.149.0/27",
  "74.125.149.128/27",
  "74.125.149.160/27",
  "74.125.149.192/27",
  "74.125.149.224/27",
  "74.125.149.32/27",
  "74.125.149.64/27",
  "74.125.149.96/27",
  "74.125.150.0/27",
  "74.125.150.32/27",
  "74.125.150.64/27",
  "74.125.150.96/27",
  "74.125.151.0/27",
  "74.125.151.128/27",
  "74.125.151.160/27",
  "74.125.151.192/27",
  "74.125.151.224/27",
  "74.125.151.32/27",
  "74.125.151.64/27",
  "74.125.151.96/27",
  "74.125.216.0/27",
  "74.125.216.128/27",
  "74.125.216.160/27",
  "74.125.216.192/27",
  "74.125.216.224/27",
  "74.125.216.32/27",
  "74.125.216.64/27",
  "74.125.216.96/27",
  "74.125.217.0/27",
  "74.125.217.128/27",
  "74.125.217.160/27",
  "74.125.217.32/27",
  "74.125.217.64/27",
  "74.125.217.96/27",
  "74.125.218.0/27",
  "74.125.218.128/27",
  "74.125.218.160/27",
  "74.125.218.192/27",
  "74.125.218.224/27",
  "74.125.218.32/27",
  "74.125.218.64/27",
  "74.125.218.96/27",
  "74.125.219.0/27",
  "74.125.219.32/27",
]

interface GeoJsResponse {
  country: string
  country_3: string
  name: string
  ip: string
}

const geolocateByIp = async (ip: string): Promise<string | null> => {
  try {
    const response = await fetch(
      `https://get.geojs.io/v1/ip/country/${ip}.json`
    )
    if (!response.ok) {
      return null
    }
    const { country }: GeoJsResponse = await response.json()
    return country.toLowerCase()
  } catch (e) {
    return null
  }
}
const getIpAddress = async (): Promise<string | null> => {
  try {
    const response = await fetch(`https://api.ipify.org/?format=json`)
    if (!response.ok) {
      return null
    }
    const { ip }: IpResponse = await response.json()
    // Very basic check to see if the IP address is a googlebot address.
    // In real world scenario more robust check is needed.
    if (googleBotAddresses.some((address) => address.startsWith(ip))) {
      return null
    }
    return ip
  } catch (e) {
    return null
  }
}

export const defaultLocation = "US"

export const detectCurrentLocation = async () => {
  try {
    const ip = await getIpAddress()
    if (!ip) throw new Error()
    return geolocateByIp(ip)
  } catch (error) {
    return null
  }
}
